import { FC, MouseEvent, ReactNode } from 'react'
import styled from 'styled-components'
import { useRouter } from 'hooks/hooks'
import { Apps } from '../../utils'
import { constants } from '@epidemicsound/design-system'
import { toAnchor } from 'utils/methods'

const StyledLink = styled.a`
    color: ${constants.COLORS.WHITE};
    padding: calc(0.5rem - 2px) 0;

    &:hover {
        text-decoration: underline;
    }
`

export type Target = '_self' | '_blank'

export interface Route {
    path?: string
    url: string
}

export interface LinkProps {
    href?: string
    to?: Route
    id?: string
    children: ReactNode
    onClick?: (e: MouseEvent<HTMLElement>) => void
    target?: Target
    app?: Apps
    isAnchor?: boolean
}

export const Link: FC<LinkProps> = ({
    href,
    to,
    id,
    children,
    onClick,
    target = '_self',
    app = 'Internal',
    isAnchor = false,
    ...props
}) => {
    const [push] = useRouter(app)

    if (!href && !to && !onClick && isAnchor === false) return null

    const routeTo = (to: Route | undefined) => {
        if (!to) return

        const { path, url } = to
        if (path) {
            push(path, url)
        } else {
            push(url)
        }
    }

    if (isAnchor && children) {
        const anchor = toAnchor(children.toString())
        return (
            <StyledLink
                id={anchor}
                href={'#' + anchor}
                target={target}
                {...props}
            >
                {children}
            </StyledLink>
        )
    } else if (onClick) {
        return (
            <StyledLink id={id} href="#" onClick={onClick} {...props}>
                {children}
            </StyledLink>
        )
    } else if (href) {
        return (
            <StyledLink id={id} href={href} target={target} {...props}>
                {children}
            </StyledLink>
        )
    } else {
        return (
            <StyledLink
                id={id}
                href="#"
                onClick={() => routeTo(to)}
                target={target}
                {...props}
            >
                {children}
            </StyledLink>
        )
    }
}
